import { createStore, combineReducers,applyMiddleware } from 'redux';
import {thunk} from 'redux-thunk';
import { notificationReducer } from "./Redux/reducers/notificationReducer";
import {patientsReducer} from "./Redux/reducers/patientReducer";
import {accountsReducer} from "./Redux/reducers/accountReducer";
import { commonReducer } from './Redux/reducers/commonReducer';
import { clinicReducer } from './Redux/reducers/clinicReducer';
import {usersReducer} from "./Redux/reducers/userRedcuer"
import { appointmentsReducer } from './Redux/reducers/appointmentReducer';
import { paymentsReducer } from './Redux/reducers/paymentReducer';
import { proceduresReducer } from './Redux/reducers/procedureReducer';
import cartReducer from './Redux/reducers/cartReducer';
import { ordersReducer } from './Redux/reducers/ordersReducer';
import { walletsReducer } from './Redux/reducers/walletsReducer';
import { rpmReducer } from './Redux/reducers/rpmReducer';
import { membershipReducer } from './Redux/reducers/membershipReducer';
import { templateReducer } from './Redux/reducers/templateReducer';
import { demoRequestReducer } from './Redux/reducers/demoReducer';

export const RESET_STORE = 'RESET_STORE';

const appReducer = combineReducers({
  notification: notificationReducer,
  patients: patientsReducer,
  accounts:accountsReducer,
  clinics:clinicReducer,
  users:usersReducer,
  appointments:appointmentsReducer,
  payments:paymentsReducer,
  procedures:proceduresReducer,
  common:commonReducer,
  cart: cartReducer,
  orders:ordersReducer,
  wallets:walletsReducer,
  rpm:rpmReducer,
  memberships:membershipReducer,
  templates:templateReducer,
  demoRequests:demoRequestReducer
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STORE) {
    state = undefined; // all reducers fall back to their initialState
  }
  return appReducer(state, action);
};

const store = createStore(rootReducer,applyMiddleware(thunk));

export default store;
